<template>
  <div class="w-5 h-5 relative flex items-center justify-center">
    <!-- Icon Container with JavaScript-driven animation -->
    <transition
      name="icon-transition"
      mode="out-in"
      @enter="onEnter"
      @leave="onLeave"
    >
      <!-- Chat icon when closed -->
      <BsChatSquareTextFill
        v-if="!isOpen"
        key="chat"
        class="absolute inset-0 w-5 h-5"
        :style="chatIconStyle"
      />
      <!-- Close/Down icon when open -->
      <AkChevronDown 
        v-else 
        key="close" 
        class="absolute inset-0 w-5 h-5"
        :style="closeIconStyle"
      />
    </transition>
  </div>
</template>

<script>
import { BsChatSquareTextFill, AkChevronDown } from '@kalimahapps/vue-icons';

export default {
  name: 'ChatBubbleIcon',
  components: {
    BsChatSquareTextFill,
    AkChevronDown
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      chatIconStyle: {
        transform: 'translate(-50%, -50%) rotate(0deg) scale(1)',
        opacity: '1',
        transition: 'all 0.12s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'absolute',
        top: '50%',
        left: '50%'
      },
      closeIconStyle: {
        transform: 'translate(-50%, -50%) rotate(0deg) scale(1)',
        opacity: '1',
        transition: 'all 0.12s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'absolute',
        top: '50%',
        left: '50%'
      }
    }
  },
  methods: {
    onEnter(el, done) {
      // Icon entering animation
      el.style.transform = 'translate(-50%, -50%) rotate(45deg) scale(0)';
      el.style.opacity = '1';
      
      // Force repaint
      el.offsetHeight;
      
      // Animate to final state
      setTimeout(() => {
        el.style.transform = 'translate(-50%, -50%) rotate(0deg) scale(1)';
        el.style.opacity = '1';
        
        setTimeout(done, 120); // Match transition duration
      }, 10);
    },
    
    onLeave(el, done) {
      // Icon leaving animation
      el.style.transform = 'translate(-50%, -50%) rotate(0deg) scale(1)';
      el.style.opacity = '1';
      
      // Force repaint
      el.offsetHeight;
      
      // Animate to exit state
      setTimeout(() => {
        el.style.transform = 'translate(-50%, -50%) rotate(0deg) scale(0)';
        el.style.opacity = '1';
        
        setTimeout(done, 100); // Slightly faster for leave
      }, 10);
    }
  }
}
</script>